import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getPlaybookType, isDealPlaybook } from './helpers';
import { setStage } from './store/stage/actions';
import { setStatus } from './store/status/actions';

import StageSelect from 'bundles/apex/stage_select';
import StatusSelect from './status_select';

export function PlaybookStages({
  playbookTypeOptions,
  playbook,
  setStage,
  setStatus,
  stage,
  stages,
  status,
  statusOptions,
}) {
  const playbookTypeLabel = playbookTypeOptions.find(option => option.value === getPlaybookType(playbook)).label;

  let prefix = 'a';
  if (playbook.dealType === 'other') {
    prefix = 'an';
  }

  let suffix = '';
  if (playbook.dealType === 'buyer_rep' || playbook.dealType === 'tenant_rep' || playbook.dealType === 'other') {
    suffix = 'deal';
  }

  let select;
  if (isDealPlaybook(playbook)) {
    select = <StageSelect setStage={setStage} stage={stage} stages={stages} />;
  } else {
    select = (
      <StatusSelect
        listingType={playbook.listingType}
        setStatus={setStatus}
        status={status}
        statusOptions={statusOptions}
      />
    );
  }

  return (
    <div className="my-5">
      <div className="d-flex align-items-center gap-1 fs-large">
        When {prefix} <b>{playbookTypeLabel}</b> {suffix} transitions to {select}
      </div>
    </div>
  );
}


PlaybookStages.propTypes = {
  playbook: PropTypes.shape({
    dealType: PropTypes.string,
    listingType: PropTypes.string,
  }).isRequired,
  playbookTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  setStage: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
  stage: PropTypes.object,
  stages: PropTypes.object.isRequired,
  status: PropTypes.object,
  statusOptions: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  playbookTypeOptions: state.playbookTypeOptions,
  stage: state.stage,
  stages: state.stages,
  status: state.status,
  statusOptions: state.statusOptions,
});

const mapDispatchToProps = {
  setStage,
  setStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaybookStages);
